import { KatalComponent } from '../../shared/base';
import { createElement } from '../../shared/utils';

/**
 * @component {kat-flag} KatalFlag A flag component will allow you to display a countries flag, more countries will be coming
 * @guideline Do Use correct size, default is small
 * @example Small-USA-Flag {"country": "us", "size":"small"}
 * @example Large-USA-Flag {"country": "us", "size":"large"}
 * @example Large-Colombia-Flag {"country": "co", "size":"large"}
 * @status Production
 * @theme flo
 */
export class KatalFlag extends KatalComponent {
  static get observedAttributes() {
    return ['size', 'country'];
  }

  constructor() {
    super(KatalFlag.observedAttributes);
  }

  connectedCallback() {
    super.connectedCallback();
    this.render();
  }

  /**
   * @required
   * @param {enum} country This is the two letter ISO code of the country - Default is "us"
   * @enum {value} at Austria
   * @enum {value} au Australia
   * @enum {value} be Belgium
   * @enum {value} br Brazil
   * @enum {value} ca Canada
   * @enum {value} cn China
   * @enum {value} co Colombia
   * @enum {value} cz Czech Republic
   * @enum {value} dk Denmark
   * @enum {value} do Dominican Republic
   * @enum {value} eu European Union
   * @enum {value} fi Finland
   * @enum {value} fr France
   * @enum {value} de Germany
   * @enum {value} hk Hong Kong
   * @enum {value} ie Ireland
   * @enum {value} in India
   * @enum {value} it Italy
   * @enum {value} jp Japan
   * @enum {value} mx Mexico
   * @enum {value} nl Netherlands
   * @enum {value} kp North Korea
   * @enum {value} no Norway
   * @enum {value} pl Poland
   * @enum {value} ru Russia
   * @enum {value} es Spain
   * @enum {value} kr South Korea
   * @enum {value} se Sweden
   * @enum {value} ch Switzerland
   * @enum {value} tr Turkey
   * @enum {value} uk United Kingdom
   * @enum {value} us United States
   * @enum {value} sa Saudi Arabia
   * @enum {value} ae United Arab Emirates
   * @enum {value} eg Egypt
   * @enum {value} sg Singapore
   */
  get country() {
    if (this.getAttribute('country')) {
      return this.getAttribute('country').toLowerCase();
    } else {
      return 'us';
    }
  }

  set country(value) {
    this.setAttribute('country', value.toLowerCase());
  }

  /**
   * @param {enum} size This is the size of the flag - Default is small
   * @enum {value} tiny Tiny
   * @enum {value} small Small - Default
   * @enum {value} large Large
   */
  get size() {
    if (this.getAttribute('size')) {
      return this.getAttribute('size').toLowerCase();
    } else {
      return 'small';
    }
  }

  set size(value) {
    this.setAttribute('size', value);
  }

  render() {
    this.innerHTML = '';
    const name = `flag-${this.country}`;
    const size = this.size;
    const el = createElement('kat-icon', { name, size });
    this.appendChild(el);
  }

  // Respond to attribute changes.
  attributeChangedCallback() {
    this.render();
  }
}

KatalComponent.register('kat-flag', KatalFlag);
